import { QuotationDeliverableForm } from '@teem/model-forms/quotation-deliverable-form';
import { FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { QuotationDeliverable } from '@teem/models/quotation-deliverable';
import { Quotation } from '@teem/models/quotation';

export class QuotationForm {
  uuid = new FormControl();
  currency = new FormControl('SAR');
  title = new FormControl(null);
  quotation_number = new FormControl('', [Validators.required]);
  quotation_date = new FormControl('', [Validators.required]);
  client_id = new FormControl('', [Validators.required]);
  is_draft = new FormControl(0);
  discount_type = new FormControl('percentage');
  total_amount = new FormControl(0);
  project_type = new FormControl(null);
  include_tax = new FormControl(false);
  tax_percent = new FormControl();
  discount =  new FormControl(null,[Validators.min(0),Validators.max(100)]);
  delivery_fee =  new FormControl();
  original_amount = new FormControl(null);
  discounted_amount = new FormControl(null);
  items = new FormArray([]);
  include_payment_info = new FormControl(false);
  save_default_payment_info = new FormControl(false);
  additional_info = new FormControl(null);
  action = new FormControl(null);
  tax_type = new FormControl(2);

  constructor(quotation: Quotation) {

    if (quotation) {
      this.title.setValue(quotation.title);
      this.quotation_number.setValue(quotation.quotation_number);
      this.quotation_date.setValue(quotation.quotation_date);
      this.total_amount.setValue(quotation.total_amount);
      this.client_id.setValue(quotation.client_id);
      this.project_type.setValue(quotation.project_type);
      this.include_tax.setValue(quotation.include_tax);
      this.additional_info.setValue(quotation.additional_info);
      this.discount.setValue(quotation.discount);
      this.delivery_fee.setValue(quotation.delivery_fee);
      this.original_amount.setValue(quotation.original_amount);
      this.discounted_amount.setValue(quotation.discounted_amount);
      this.discount_type.setValue(quotation.discount_type);
      this.tax_type.setValue(quotation.tax_type);
      if (quotation.tax_percent) {
        this.include_tax.setValue(true)
        this.tax_percent.setValue(quotation.tax_percent)
      }

      if (quotation.items && quotation.items.length) {
        let fb = new FormBuilder();
        quotation.items.forEach((item) => {
          this.items.push(
            fb.group(new QuotationDeliverableForm(new QuotationDeliverable(item)))
          )
        })
      }
    }
  }
}
